{
  "COMMON": {
    "FULFILLMENT_PROJECTS_AND_TASKS": "Fulfillment projects & tasks",
    "PRODUCT": "Product",
    "PRODUCTS": "Products",
    "ORDER": "Order",
    "ACCOUNTS": "Accounts",
    "USER": "User",
    "USERS": "Users",
    "ORDERS": "Orders",
    "AUXILIARY_DATA": {
      "SCHEMA": {
        "NAME": "Name",
        "DESCRIPTION": "Description",
        "TYPE": "Field type",
        "OBJECT": "Object",
        "DROPDOWN": {
          "LABEL": "Label",
          "LABEL_HINT": "What you will see as an option in the dropdown. (e.g. Top Tier, Middle Tier, Low Tier) - max 100 characters",
          "VALUE": "Value",
          "VALUE_HINT": "Used to match against CSV or form values. (e.g.top-tier, mid-tier, low-tier)",
          "OPTION_FIELDS_LIMIT": "A maximum number of 200 options can be created per dropdown field"
        }
      },
      "TYPES": {
        "STRING": "Text",
        "INTEGER": "Integer",
        "DATE": "Date",
        "DROPDOWN": "Dropdown",
        "CURRENCY": "Currency"
      },
      "CREATE_HEADER": "Create custom field",
      "EDIT_HEADER": "Edit custom field",
      "EXTERNAL_IDENTIFIER": "External Identifier",
      "SET": "Set",
      "SET_IDENTIFIER": "Set Identifier",
      "EDIT_IDENTIFIER": "Edit Identifier",
      "IDENTIFIER_VALIDATION_MESSAGE": "Only lowercase letters, numbers, dash (-) and underscore (_) permitted",
      "IDENTIFIER_DUPLICATE_MESSAGE": "This external identifier is currently in use",
      "EXTERNAL_IDENTIFIER_DESCRIPTION": "This is what will be used to identify this field when working with the API.",
      "EXTERNAL_IDENTIFIER_WARNING": "Warning: Changing this will require changes in your code if you're using the API."
    },
    "MANAGE_ATTRIBUTES": "Manage custom fields",
    "INVALID_DROPDOWN_ERROR": "Select a valid option",
    "ADD_FIELD": "Add {{fieldName}}...",
    "ACTION_LABELS": {
      "ACTIONS": "Actions",
      "CANCEL": "Cancel",
      "CONTINUE": "Continue",
      "LEARN_MORE": "Learn more",
      "CONTACT_US": "Contact us",
      "MORE": "More",
      "VIEW_MORE": "View more",
      "WANT_TO_LEARN_MORE": "Want to learn more?",
      "TALKE_A_COURSE": "Take a course!",
      "SHOW": "Show",
      "SHOW_ALL": "Show all",
      "SHOW_LESS": "Show less",
      "LESS": "Less",
      "NEXT": "Next",
      "BACK": "Back",
      "CLOSE": "Close",
      "REMOVE": "Remove",
      "CREATE": "Create",
      "EDIT": "Edit",
      "UPDATE": "Update",
      "RETRY": "Retry",
      "DONE": "Done",
      "DELETE": "Delete",
      "ADD": "Add",
      "ADD_NEW": "Add new",
      "NONE_LABEL": "None",
      "NO_RESULTS": "No results",
      "SEND": "Send",
      "SUBMIT": "Submit",
      "SELECT_DATE": "Select date",
      "SAVE": "Save",
      "LOAD_MORE": "Load more",
      "SEARCH": "Search",
      "VIEW": "View",
      "VIEW_DETAILS": "View details",
      "VIEW_LESS": "View less",
      "DISMISS": "Dismiss",
      "CONFIRM": "Confirm",
      "OK": "OK",
      "SELECT": "Select"
    },

    "TABLE": {
      "OF": "of",
      "OF_MANY": "of many",
      "NO_RESULTS": "No results found for filters",
      "SHOWING_PAGE_OF_TOTAL": "Showing {{page}} of {{total}}",
      "TABLE_SHOWING": "Showing {{page}} of {{total}} results",
      "TABLE_SHOWING_OVER_RESULT": "Showing {{page}} of over {{total}} results",
      "TABLE_SHOWING_ALL_RESULT": "Showing all {{total}} results",
      "EXPORT": {
        "BUTTON": "Export",
        "BUTTON_TOOLTIP_BEFORE_COUNT": "Export",
        "BUTTON_TOOLTIP_AFTER_COUNT": "items"
      },
      "COLUMN_SELECTOR": {
        "BUTTON": "Columns"
      }
    }
  },
  "AUXILIARY_DATA_TABLE": {
    "ATTRIBUTE_COLUMN": "Custom field",
    "DATA_COLUMN": "Data on file",
    "EMPTY": {
      "TITLE": "Leverage custom data in your workflow",
      "TEXT": "Quickly and easily collect data based on custom fields within the system and improve your data collection, storage, and reporting capabilities.",
      "BUTTON": "Set up custom fields"
    },
    "ERROR": {
      "TITLE": "Something went wrong",
      "TEXT": "Please wait a few moments and try again. If the problem persists, please contact an administrator"
    },
    "STRING_LIMIT_HINT": "{{characters}} characters (maximum 4000 characters)",
    "DELETED_ACCOUNT": "This account was recently deleted, and its custom data is still being processed."
  },
  "FIELD_NOT_YET_SUPPORTED": "This field is not yet supported, please choose another field.",
  "AUXILIARY_DATA_CARD": {
    "CARD_TITLE": "Custom fields",
    "SAVE": {
      "SUCESS": "Custom fields saved successfully",
      "ERROR": "Something went wrong"
    },
    "ERROR": {
      "TITLE": "Something went wrong",
      "TEXT": "Please wait a few moments and try again. If the problem persists, please contact an administrator"
    }
  },
  "AUXILIARY_DATA_PANEL": {
    "PANEL_TITLE": "Custom fields",
    "PANEL_DESCRIPTION": "Custom fields for the account",
    "ERROR": {
      "TITLE": "Something went wrong",
      "TEXT": "Please wait a few moments and try again. If the problem persists, please contact an administrator"
    }
  },
  "ADMINISTRATION": {
    "CUSTOM_FIELDS": {
      "TITLE": "Custom fields",
      "DESCRIPTION": "Add and capture more information on customer accounts, users, and products",
      "SELECT_OBJECT_TYPE": "Select object type:",
      "SAVE_SUCCESS": "Field created successfully",
      "EDIT_SUCCESS": "Field edited successfully",
      "SAVE_ERROR": "Failed to create field",
      "EDIT_ERROR": "Failed to edit field",
      "CREATE_LABEL": "Create custom field",
      "REACHED_CREATION_LIMIT": "Limit reached",
      "TOO_MANY_CUSTOM_FIELDS": "A maximum number of 100 custom fields can be created per partner",
      "NAME_HINT": "{{characters}} characters (maximum 50 characters)",
      "DESCRIPTION_HINT": "{{characters}} characters (maximum 200 characters)",
      "ARCHIVED": "Archived fields",
      "ARCHIVE_SUCCESS": "'{{fieldName}}' was successfully archived.",
      "ARCHIVE_FAILURE": "Failed to archive '{{fieldName}}' field.",
      "UNARCHIVE_SUCCESS": "'{{fieldName}}' was successfully unarchived.",
      "UNARCHIVE_FAILURE": "Failed to unarchive '{{fieldName}}' field.",
      "CURRENCY_TYPE": "Currency Type",
      "FIELD_TYPE_NOT_EDITABLE": "This field cannot be edited after it’s created",
      "ARCHIVE_DIALOG": {
        "TITLE": "Archive field?",
        "CONTENT": "Automations that rely on <strong>{{fieldName}}</strong> may need to be updated.",
        "AUTOMATION_LINK": "Manage automations",
        "ARCHIVE": "Archive"
      },
      "EMPTY_STATE_TITLE": "Create custom fields",
      "EMPTY_STATE_DESCRIPTION": "Use custom fields to record unique information about accounts, users, products, and orders, as well as fulfillment projects and tasks. Information stored in custom fields can be used to segment campaigns, trigger automations, and more.",
      "EMPTY_STATE_LEARN_MORE": "Learn more"
    }
  }
}
